
define('template!lmbAnaCreateEditLayoutTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="detailed-info-form-container">\n  <div class="saving-label"></div>\n  <div class="error-label">' +
((__t = ( _.i18n('common.serverError') )) == null ? '' : __t) +
'\n      <div class="error-msg">  </div>\n  </div>\n  <div class="form-horizontal">\n    <div class="form-inputs-container">\n      <div class="form-group" data-field-name="code">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('common.code') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="text" class="form-control floating-label js-info-input js-code"\n                 data-field-name="code" placeholder="' +
((__t = ( _.i18n('common.code') )) == null ? '' : __t) +
'"\n                 value="' +
((__t = ( code )) == null ? '' : __t) +
'" data-content="' +
((__t = ( _.i18n('lmbana.duplicatedCodeError') )) == null ? '' : __t) +
'"\n                 data-placement="top">\n        </div>\n      </div>\n      <div class="form-group">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('lmbana.refMbAna') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <div class="js-select-mbana-region"></div>\n        </div>\n      </div>\n      <div class="form-group" data-field-name="shortname">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('lmbana.shortname') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="text" class="form-control floating-label js-info-input input-shortname" data-field-name="shortname" placeholder="' +
((__t = ( _.i18n('lmbana.shortname') )) == null ? '' : __t) +
'" value="' +
((__t = ( shortname )) == null ? '' : __t) +
'">\n        </div>\n      </div>\n      <div class="form-group" data-field-name="rptname">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('lmbana.rptname') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <textarea class="form-control floating-label js-info-input" rows="4" data-field-name="rptname" placeholder="' +
((__t = ( _.i18n('lmbana.rptname') )) == null ? '' : __t) +
'">' +
((__t = ( rptname )) == null ? '' : __t) +
'</textarea>\n        </div>\n      </div>\n      <div class="form-group" data-field-name="testCodeLIS">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('lmbana.testCodeLIS') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="text" class="form-control floating-label js-info-input" data-field-name="testCodeLIS" placeholder="' +
((__t = ( _.i18n('lmbana.testCodeLIS') )) == null ? '' : __t) +
'" value="' +
((__t = ( testCodeLIS )) == null ? '' : __t) +
'">\n        </div>\n      </div>\n      <div class="row">\n        <div class="pull-right p-r-15">\n          <button class="btn btn-default btn-flat cancel-b js-cancel-popup">' +
((__t = ( _.i18n('common.cancel') )) == null ? '' : __t) +
'</button>\n          <button disabled class="btn btn-primary disabled-grey js-confirm">' +
((__t = ( _.i18n('common.confirm') )) == null ? '' : __t) +
'</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
};});

